import { render, staticRenderFns } from "./supplierOrderHistories.vue?vue&type=template&id=530faf18&scoped=true&"
import script from "./supplierOrderHistories.vue?vue&type=script&lang=js&"
export * from "./supplierOrderHistories.vue?vue&type=script&lang=js&"
import style0 from "./supplierOrderHistories.vue?vue&type=style&index=0&id=530faf18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530faf18",
  null
  
)

component.options.__file = "supplierOrderHistories.vue"
export default component.exports